{
  "title": "الإشعارات",
  "bell": {
    "label": "الإشعارات",
    "labelUnread": "الإشعارات: {{n}} غير مقروءة"
  },
  "filter": {
    "label": "أي الإشعارات",
    "all": "الكل",
    "unread": "غير المقروءة"
  },
  "markAllRead": "تعليم الكل كمقروء",
  "unread": "غير مقروء",
  "latest": "أحدث {{shown}} من {{total}}",
  "empty": {
    "title": "لا جديد لديك",
    "all": "تظهر هنا مستجدات أعمالك.",
    "unread": "لا شيء جديد منذ آخر اطلاع."
  },
  "unavailable": "تعذّر تحميل الإشعارات",
  "kinds": {
    "TASK_ASSIGNED": {
      "actor": "أسند {{actor}} المهمة {{number}} إليك",
      "system": "أُسندت إليك المهمة {{number}}"
    },
    "TASK_UNASSIGNED": {
      "actor": "أسند {{actor}} المهمة {{number}} إلى شخص آخر",
      "system": "أُسندت المهمة {{number}} إلى شخص آخر"
    },
    "TASK_QUEUED": {
      "actor": "أضاف {{actor}} المهمة {{number}} إلى قائمة فريقك",
      "system": "المهمة {{number}} تنتظر في قائمة فريقك"
    },
    "TASK_REVIEW_REQUESTED": {
      "actor": "طلب {{actor}} مراجعتك للمهمة {{number}}",
      "system": "طُلبت مراجعتك للمهمة {{number}}"
    },
    "TASK_RETURNED": {
      "actor": "أعاد {{actor}} المهمة {{number}} إليك مع ملاحظات",
      "system": "أُعيدت المهمة {{number}} مع ملاحظات"
    },
    "TASK_COMPLETED": {
      "actor": "أنجز {{actor}} المهمة {{number}}",
      "system": "أُنجزت المهمة {{number}}"
    },
    "TASK_CANCELLED": {
      "actor": "ألغى {{actor}} المهمة {{number}}",
      "system": "أُلغيت المهمة {{number}}"
    },
    "TASK_REOPENED": {
      "actor": "أعاد {{actor}} فتح المهمة {{number}}",
      "system": "أُعيد فتح المهمة {{number}}"
    },
    "TASK_COMMENTED": {
      "actor": "علّق {{actor}} على المهمة {{number}}",
      "system": "تعليق جديد على المهمة {{number}}"
    },
    "TASK_DUE_CHANGED": {
      "actor": "نقل {{actor}} تاريخ استحقاق المهمة {{number}} إلى {{date}}",
      "system": "أصبح تاريخ استحقاق المهمة {{number}} هو {{date}}",
      "actorCleared": "أزال {{actor}} تاريخ استحقاق المهمة {{number}}",
      "systemCleared": "لم يعد للمهمة {{number}} تاريخ استحقاق"
    },
    "TASK_DATE_REQUESTED": {
      "actor": "يطلب {{actor}} نقل تاريخ استحقاق المهمة {{number}} إلى {{date}}",
      "system": "طُلب نقل تاريخ استحقاق المهمة {{number}} إلى {{date}}"
    },
    "TASK_BLOCKED": {
      "actor": "سجّل {{actor}} أن المهمة {{number}} معطلة",
      "system": "المهمة {{number}} معطلة",
      "actorFollowUp": "سجّل {{actor}} أن المهمة {{number}} معطلة، والمتابعة في {{date}}",
      "systemFollowUp": "المهمة {{number}} معطلة، والمتابعة في {{date}}"
    },
    "TASK_UNBLOCKED": {
      "actor": "رفع {{actor}} التعطيل عن المهمة {{number}}",
      "system": "لم تعد المهمة {{number}} معطلة"
    },
    "TASK_PERSON_ADDED": {
      "CONTRIBUTOR": {
        "actor": "أضافك {{actor}} مساهمًا في المهمة {{number}}",
        "system": "أُضفت مساهمًا في المهمة {{number}}"
      },
      "FOLLOWER": {
        "actor": "أضافك {{actor}} متابعًا للمهمة {{number}}",
        "system": "أصبحت متابعًا للمهمة {{number}}"
      }
    },
    "TASK_DUE_TODAY": "المهمة {{number}} مستحقة اليوم",
    "TASK_OVERDUE": {
      "undated": "المهمة {{number}} متأخرة",
      "days_zero": "المهمة {{number}} متأخرة",
      "days_one": "المهمة {{number}} متأخرة يومًا واحدًا",
      "days_two": "المهمة {{number}} متأخرة يومين",
      "days_few": "المهمة {{number}} متأخرة {{n}} أيام",
      "days_many": "المهمة {{number}} متأخرة {{n}} يومًا",
      "days_other": "المهمة {{number}} متأخرة {{n}} يوم"
    },
    "TASK_OVERDUE_ESCALATED": {
      "undated": "المهمة {{number}} في فريق تقوده متأخرة",
      "days_zero": "المهمة {{number}} في فريق تقوده متأخرة",
      "days_one": "المهمة {{number}} في فريق تقوده متأخرة يومًا واحدًا",
      "days_two": "المهمة {{number}} في فريق تقوده متأخرة يومين",
      "days_few": "المهمة {{number}} في فريق تقوده متأخرة {{n}} أيام",
      "days_many": "المهمة {{number}} في فريق تقوده متأخرة {{n}} يومًا",
      "days_other": "المهمة {{number}} في فريق تقوده متأخرة {{n}} يوم"
    },
    "TASK_FOLLOW_UP_DUE": "اليوم موعد متابعة ما يعطّل المهمة {{number}}",
    "SERVICE_VISIT_SCHEDULED": {
      "actor": "جدول {{actor}} زيارة لـ{{number}} لفريقك",
      "system": "جُدولت زيارة لـ{{number}} لفريقك"
    },
    "SERVICE_VISIT_RESCHEDULED": {
      "actor": "أعاد {{actor}} جدولة زيارة لـ{{number}}",
      "system": "أُعيدت جدولة زيارة لـ{{number}}"
    },
    "SERVICE_VISIT_CANCELLED": {
      "actor": "ألغى {{actor}} زيارة لـ{{number}}",
      "system": "أُلغيت زيارة لـ{{number}}"
    },
    "SERVICE_FOLLOW_UP_REQUESTED": {
      "actor": "يطلب {{actor}} زيارة متابعة لـ{{number}}",
      "system": "طُلبت زيارة متابعة لـ{{number}}"
    },
    "SERVICE_FOLLOW_UP_APPROVED": {
      "actor": "اعتمد {{actor}} زيارة المتابعة التي طلبتها لـ{{number}}",
      "system": "اعتُمدت زيارة المتابعة التي طلبتها لـ{{number}}"
    },
    "SERVICE_FOLLOW_UP_RETURNED": {
      "actor": "أعاد {{actor}} طلب المتابعة الذي قدمته لـ{{number}}",
      "system": "أُعيد طلب المتابعة الذي قدمته لـ{{number}}"
    },
    "SERVICE_COLLECTION_REPORTED": {
      "actor": "سجّل {{actor}} مبلغاً محصلاً على {{number}}: تحقق منه",
      "system": "مبلغ محصل على {{number}} بانتظار التحقق"
    },
    "SERVICE_COLLECTION_VERIFIED": {
      "actor": "تحقق {{actor}} من المبلغ الذي حصّلته على {{number}}",
      "system": "تم التحقق من المبلغ الذي حصّلته على {{number}}"
    },
    "SERVICE_COLLECTION_REJECTED": {
      "actor": "رفض {{actor}} المبلغ الذي سجّلته على {{number}}",
      "system": "رُفض المبلغ الذي سجّلته على {{number}}"
    },
    "SERVICE_CHECK_ISSUE": {
      "actor": "وجد {{actor}} مشكلة في {{asset}} بموقع {{site}}: أمر العطل {{job}}",
      "system": "وُجدت مشكلة في {{asset}} بموقع {{site}}: أمر العطل {{job}}",
      "actorPlain": "وجد {{actor}} مشكلة أثناء الفحص: أمر العطل {{job}}",
      "systemPlain": "وُجدت مشكلة أثناء الفحص: أمر العطل {{job}}"
    },
    "CONTRACT_RENEWAL_DUE": {
      "days_zero": "عقد الصيانة {{contract}} ينتهي اليوم، {{date}}",
      "days_one": "عقد الصيانة {{contract}} ينتهي خلال يوم واحد، في {{date}}",
      "days_two": "عقد الصيانة {{contract}} ينتهي خلال يومين، في {{date}}",
      "days_few": "عقد الصيانة {{contract}} ينتهي خلال {{n}} أيام، في {{date}}",
      "days_many": "عقد الصيانة {{contract}} ينتهي خلال {{n}} يومًا، في {{date}}",
      "days_other": "عقد الصيانة {{contract}} ينتهي خلال {{n}} يوم، في {{date}}",
      "dated": "عقد الصيانة {{contract}} ينتهي في {{date}}",
      "plain": "عقد الصيانة {{contract}} يقترب من نهايته"
    },
    "CONTRACT_EXPIRED": {
      "dated": "انتهى عقد الصيانة {{contract}} في {{date}}",
      "plain": "انتهى عقد الصيانة {{contract}}"
    },
    "CONTRACT_BILLING_READY": {
      "count_zero": "لا أقساط من العقد {{contract}} جاهزة للفوترة",
      "count_one": "قسط واحد من العقد {{contract}} جاهز للفوترة ({{total}})",
      "count_two": "قسطان من العقد {{contract}} جاهزان للفوترة ({{total}})",
      "count_few": "{{n}} أقساط من العقد {{contract}} جاهزة للفوترة ({{total}})",
      "count_many": "{{n}} قسطًا من العقد {{contract}} جاهزة للفوترة ({{total}})",
      "count_other": "{{n}} قسط من العقد {{contract}} جاهزة للفوترة ({{total}})",
      "plain": "أقساط من العقد {{contract}} جاهزة للفوترة"
    },
    "CONTRACT_VISITS_PLANNED": {
      "count_zero": "لا زيارات وقائية جديدة ضمن العقد {{contract}}",
      "count_one": "زيارة وقائية واحدة ضمن العقد {{contract}} جاهزة للجدولة",
      "count_two": "زيارتان وقائيتان ضمن العقد {{contract}} جاهزتان للجدولة",
      "count_few": "{{n}} زيارات وقائية ضمن العقد {{contract}} جاهزة للجدولة",
      "count_many": "{{n}} زيارة وقائية ضمن العقد {{contract}} جاهزة للجدولة",
      "count_other": "{{n}} زيارة وقائية ضمن العقد {{contract}} جاهزة للجدولة",
      "countSites_zero": "لا زيارات وقائية جديدة ضمن العقد {{contract}}",
      "countSites_one": "زيارة وقائية واحدة ضمن العقد {{contract}} جاهزة للجدولة، في {{sites}}",
      "countSites_two": "زيارتان وقائيتان ضمن العقد {{contract}} جاهزتان للجدولة، في {{sites}}",
      "countSites_few": "{{n}} زيارات وقائية ضمن العقد {{contract}} جاهزة للجدولة، في {{sites}}",
      "countSites_many": "{{n}} زيارة وقائية ضمن العقد {{contract}} جاهزة للجدولة، في {{sites}}",
      "countSites_other": "{{n}} زيارة وقائية ضمن العقد {{contract}} جاهزة للجدولة، في {{sites}}",
      "sites_zero": "لا مواقع",
      "sites_one": "موقع واحد",
      "sites_two": "موقعين",
      "sites_few": "{{n}} مواقع",
      "sites_many": "{{n}} موقعًا",
      "sites_other": "{{n}} موقع",
      "plain": "زيارات وقائية ضمن العقد {{contract}} جاهزة للجدولة"
    },
    "CONTRACT_VISIT_OVERDUE": {
      "site": "الزيارة الوقائية {{job}} بموقع {{site}} متأخرة: كان موعدها {{date}}",
      "dated": "الزيارة الوقائية {{job}} متأخرة: كان موعدها {{date}}",
      "plain": "الزيارة الوقائية {{job}} متأخرة"
    },
    "ASSET_WARRANTY_EXPIRING": {
      "site": "ينتهي ضمان {{asset}} بموقع {{site}} في {{date}}",
      "dated": "ينتهي ضمان {{asset}} في {{date}}",
      "plain": "ضمان إحدى معدات العقد {{contract}} يقترب من نهايته"
    },
    "DSR_DUE_SOON": {
      "days_zero": "طلب البيانات الشخصية من {{number}} مستحق اليوم، {{date}}",
      "days_one": "طلب البيانات الشخصية من {{number}} مستحق خلال يوم عمل واحد، في {{date}}",
      "days_two": "طلب البيانات الشخصية من {{number}} مستحق خلال يومي عمل، في {{date}}",
      "days_few": "طلب البيانات الشخصية من {{number}} مستحق خلال {{n}} أيام عمل، في {{date}}",
      "days_many": "طلب البيانات الشخصية من {{number}} مستحق خلال {{n}} يوم عمل، في {{date}}",
      "days_other": "طلب البيانات الشخصية من {{number}} مستحق خلال {{n}} يوم عمل، في {{date}}"
    },
    "DSR_OVERDUE": {
      "days_zero": "طلب البيانات الشخصية من {{number}} تجاوز موعده القانوني",
      "days_one": "طلب البيانات الشخصية من {{number}} متأخر يومًا واحدًا عن موعده القانوني",
      "days_two": "طلب البيانات الشخصية من {{number}} متأخر يومين عن موعده القانوني",
      "days_few": "طلب البيانات الشخصية من {{number}} متأخر {{n}} أيام عن موعده القانوني",
      "days_many": "طلب البيانات الشخصية من {{number}} متأخر {{n}} يومًا عن موعده القانوني",
      "days_other": "طلب البيانات الشخصية من {{number}} متأخر {{n}} يوم عن موعده القانوني"
    },
    "PROJECT_MEMBER_ADDED": {
      "actor": "أضافك {{actor}} إلى فريق {{number}}",
      "system": "أُضفت إلى فريق {{number}}"
    },
    "PROJECT_MANAGER_ASSIGNED": {
      "actor": "عيّنك {{actor}} مديرًا للمشروع {{number}}",
      "system": "أصبحت مدير المشروع {{number}}"
    },
    "PROJECT_STATUS_CHANGED": {
      "actor": "غيّر {{actor}} حالة {{number}}",
      "system": "تغيّرت حالة {{number}}"
    },
    "PROJECT_BUDGET_THRESHOLD": {
      "actor": "اقترب {{number}} من حدود موازنته",
      "system": "اقترب {{number}} من حدود موازنته",
      "WARN": "بلغ {{number}} مستوى التنبيه في موازنته",
      "CRITICAL": "بلغ {{number}} المستوى الحرج في موازنته"
    },
    "PROJECT_BUDGET_SUBMITTED": {
      "actor": "أرسل {{actor}} موازنة {{number}} لاعتمادك",
      "system": "موازنة {{number}} بانتظار اعتمادك"
    },
    "PROJECT_BUDGET_APPROVED": {
      "actor": "اعتمد {{actor}} موازنة {{number}}",
      "system": "اعتُمدت موازنة {{number}}"
    },
    "PROJECT_BILLING_READY": {
      "actor": "جعل {{actor}} «{{item}}» من {{number}} جاهزًا للفوترة",
      "system": "«{{item}}» من {{number}} جاهز للفوترة",
      "actorPlain": "جعل {{actor}} بندًا من خطة فوترة {{number}} جاهزًا للفوترة",
      "systemPlain": "بند من خطة فوترة {{number}} جاهز للفوترة"
    },
    "PROJECT_CLAIM_SUBMITTED": {
      "actor": "قدّم {{actor}} المستخلص {{claim}} للمشروع {{number}}",
      "system": "قُدّم المستخلص {{claim}} للمشروع {{number}}",
      "actorPlain": "قدّم {{actor}} مستخلصاً للمشروع {{number}}",
      "systemPlain": "قُدّم مستخلص للمشروع {{number}}"
    },
    "PROJECT_CLAIM_CERTIFIED": {
      "actor": "سجّل {{actor}} اعتماد المستخلص {{claim}} للمشروع {{number}}: صدرت فاتورته",
      "system": "اعتُمد المستخلص {{claim}} للمشروع {{number}}: صدرت فاتورته",
      "actorPlain": "سجّل {{actor}} اعتماد مستخلص للمشروع {{number}}",
      "systemPlain": "اعتُمد مستخلص للمشروع {{number}}"
    },
    "PROJECT_CLAIM_REJECTED": {
      "actor": "سجّل {{actor}} رفض العميل للمستخلص {{claim}} للمشروع {{number}}",
      "system": "رفض العميل المستخلص {{claim}} للمشروع {{number}}",
      "actorPlain": "سجّل {{actor}} رفض العميل لمستخلص للمشروع {{number}}",
      "systemPlain": "رفض العميل مستخلصاً للمشروع {{number}}"
    },
    "PROJECT_CLAIM_VOIDED": {
      "actor": "أبطل {{actor}} المستخلص {{claim}} للمشروع {{number}} وفاتورته",
      "system": "أُبطل المستخلص {{claim}} للمشروع {{number}} وفاتورته",
      "actorPlain": "أبطل {{actor}} مستخلصاً للمشروع {{number}}",
      "systemPlain": "أُبطل مستخلص للمشروع {{number}}"
    },
    "PROJECT_VARIATION_DECIDED": {
      "APPROVED": {
        "actor": "سجّل {{actor}} موافقة العميل على {{variation}} في المشروع {{number}}",
        "system": "وافق العميل على {{variation}} في المشروع {{number}}",
        "actorPlain": "سجّل {{actor}} موافقة العميل على أمر تغييري في المشروع {{number}}",
        "systemPlain": "وافق العميل على أمر تغييري في المشروع {{number}}"
      },
      "REJECTED": {
        "actor": "سجّل {{actor}} رفض العميل لـ {{variation}} في المشروع {{number}}",
        "system": "رفض العميل {{variation}} في المشروع {{number}}",
        "actorPlain": "سجّل {{actor}} رفض العميل لأمر تغييري في المشروع {{number}}",
        "systemPlain": "رفض العميل أمراً تغييرياً في المشروع {{number}}"
      }
    },
    "PROJECT_SIGNAL": {
      "signal": "{{number}}: {{signal}}",
      "plain": "تنبيه جديد على المشروع {{number}}"
    },
    "PROJECT_SIGNAL_DIGEST": {
      "count_zero": "لا تنبيهات أخرى للمشاريع اليوم",
      "count_one": "تنبيه آخر واحد للمشاريع اليوم",
      "count_two": "تنبيهان آخران للمشاريع اليوم",
      "count_few": "{{n}} تنبيهات أخرى للمشاريع اليوم",
      "count_many": "{{n}} تنبيهًا آخر للمشاريع اليوم",
      "count_other": "{{n}} تنبيه آخر للمشاريع اليوم",
      "plain": "تنبيهات أخرى للمشاريع اليوم"
    },
    "PROJECT_GUARANTEE_EXPIRING": {
      "days_zero": "{{guarantee}} للمشروع {{number}} ينتهي اليوم، {{date}}",
      "days_one": "{{guarantee}} للمشروع {{number}} ينتهي خلال يوم واحد، في {{date}}",
      "days_two": "{{guarantee}} للمشروع {{number}} ينتهي خلال يومين، في {{date}}",
      "days_few": "{{guarantee}} للمشروع {{number}} ينتهي خلال {{n}} أيام، في {{date}}",
      "days_many": "{{guarantee}} للمشروع {{number}} ينتهي خلال {{n}} يومًا، في {{date}}",
      "days_other": "{{guarantee}} للمشروع {{number}} ينتهي خلال {{n}} يوم، في {{date}}",
      "dated": "{{guarantee}} للمشروع {{number}} ينتهي في {{date}}",
      "plain": "ضمان للمشروع {{number}} يقترب من الانتهاء"
    },
    "PROJECT_GUARANTEE_EXPIRED": {
      "dated": "{{guarantee}} للمشروع {{number}} انتهى في {{date}}",
      "plain": "انتهى ضمان للمشروع {{number}}"
    },
    "PROJECT_RECONCILIATION_DIFFERENCE": {
      "identity": "{{number}}: يختلف دفتر الأستاذ عن المشاريع في {{account}} بتاريخ {{date}}",
      "plain": "أرقام عقد المشروع {{number}} لا تطابق دفتر الأستاذ",
      "untraced": "في دفتر الأستاذ قيود على {{account}} لا ترتبط بأي مشروع بتاريخ {{date}}"
    },
    "PROJECT_CONTRACT_APPROVAL_PENDING": "{{name}} للمشروع {{project}} بانتظار موافقتك",
    "PROJECT_CONTRACT_APPROVAL_RETURNED": {
      "actor": "أعاد {{actor}} {{name}} للمشروع {{project}} إلى المسودة",
      "actorReason": "أعاد {{actor}} {{name}} للمشروع {{project}} إلى المسودة: {{reason}}",
      "system": "أُعيد {{name}} للمشروع {{project}} إلى المسودة",
      "systemReason": "أُعيد {{name}} للمشروع {{project}} إلى المسودة: {{reason}}"
    },
    "PROJECT_TIME_SUBMITTED": {
      "hours_zero": "أرسل {{person}} {{hours}} على {{project}} للاعتماد عن أسبوع {{date}}",
      "hours_one": "أرسل {{person}} {{hours}} على {{project}} للاعتماد عن أسبوع {{date}} (سجل وقت واحد)",
      "hours_two": "أرسل {{person}} {{hours}} على {{project}} للاعتماد عن أسبوع {{date}} (سجلّا وقت)",
      "hours_few": "أرسل {{person}} {{hours}} على {{project}} للاعتماد عن أسبوع {{date}} ({{n}} سجلات وقت)",
      "hours_many": "أرسل {{person}} {{hours}} على {{project}} للاعتماد عن أسبوع {{date}} ({{n}} سجل وقت)",
      "hours_other": "أرسل {{person}} {{hours}} على {{project}} للاعتماد عن أسبوع {{date}} ({{n}} سجل وقت)",
      "plain": "وقت على {{project}} بانتظار اعتمادك"
    },
    "PROJECT_TIME_RETURNED": {
      "actor_zero": "أرجع {{actor}} وقتك على {{project}} (أسبوع {{date}})",
      "actor_one": "أرجع {{actor}} سجل وقت واحدًا من وقتك على {{project}} (أسبوع {{date}})",
      "actor_two": "أرجع {{actor}} سجلَّي وقت من وقتك على {{project}} (أسبوع {{date}})",
      "actor_few": "أرجع {{actor}} {{n}} سجلات وقت من وقتك على {{project}} (أسبوع {{date}})",
      "actor_many": "أرجع {{actor}} {{n}} سجل وقت من وقتك على {{project}} (أسبوع {{date}})",
      "actor_other": "أرجع {{actor}} {{n}} سجل وقت من وقتك على {{project}} (أسبوع {{date}})",
      "actorReason_zero": "أرجع {{actor}} وقتك على {{project}} (أسبوع {{date}}): {{reason}}",
      "actorReason_one": "أرجع {{actor}} سجل وقت واحدًا من وقتك على {{project}} (أسبوع {{date}}): {{reason}}",
      "actorReason_two": "أرجع {{actor}} سجلَّي وقت من وقتك على {{project}} (أسبوع {{date}}): {{reason}}",
      "actorReason_few": "أرجع {{actor}} {{n}} سجلات وقت من وقتك على {{project}} (أسبوع {{date}}): {{reason}}",
      "actorReason_many": "أرجع {{actor}} {{n}} سجل وقت من وقتك على {{project}} (أسبوع {{date}}): {{reason}}",
      "actorReason_other": "أرجع {{actor}} {{n}} سجل وقت من وقتك على {{project}} (أسبوع {{date}}): {{reason}}",
      "plain": "أُرجع إليك جزء من وقتك على {{project}}"
    },
    "AI_BUDGET_THRESHOLD": {
      "percent": "استخدم المساعد الذكي {{pct}} من الوحدات النصية (tokens) لهذا الشهر ({{used}} من {{limit}})",
      "percentMonth": "استخدم المساعد الذكي {{pct}} من الوحدات النصية (tokens) لشهر {{month}} ({{used}} من {{limit}})",
      "reached": "استخدم المساعد الذكي كل الوحدات النصية (tokens) لهذا الشهر ({{used}} من {{limit}}). يتوقف حتى الشهر القادم، ما لم يرفع المسؤول الحد في الإعدادات › المساعد الذكي، أو يرفع مزوّد خدمة سحاب لديكم سقفه.",
      "reachedMonth": "استخدم المساعد الذكي كل الوحدات النصية (tokens) لشهر {{month}} ({{used}} من {{limit}})",
      "plain": "اقترب المساعد الذكي من حدّه الشهري من الوحدات النصية (tokens)"
    },
    "BOOKS_HEALTH_DIGEST": {
      "summary": "سلامة الدفاتر، {{period}}: {{counts}} بحاجة إلى مراجعة",
      "critical_zero": "{{n}} مشكلة حرجة",
      "critical_one": "مشكلة حرجة واحدة",
      "critical_two": "مشكلتان حرجتان",
      "critical_few": "{{n}} مشكلات حرجة",
      "critical_many": "{{n}} مشكلة حرجة",
      "critical_other": "{{n}} مشكلة حرجة",
      "warning_zero": "{{n}} تحذير",
      "warning_one": "تحذير واحد",
      "warning_two": "تحذيران",
      "warning_few": "{{n}} تحذيرات",
      "warning_many": "{{n}} تحذيرًا",
      "warning_other": "{{n}} تحذير",
      "and": "{{first}} و{{second}}",
      "range": "{{from}} إلى {{to}}",
      "plain": "وجدت سلامة الدفاتر مشكلات بحاجة إلى مراجعة"
    },
    "CHEQUES_DUE": {
      "received": "{{cheques}} ({{amount}}) في الصندوق حلّ تاريخها: أودِعها",
      "receivedLate": "{{cheques}} ({{amount}}) في الصندوق حلّ تاريخها للإيداع؛ و{{late}} مودعة لم تُصرف بعد",
      "lateOnly": "{{late}} مودعة لم تُصرف بعد: راجع البنك",
      "issued": "{{cheques}} صادرة منك ({{amount}}) قد تُقدَّم للصرف حتى {{date}}: احرص على توفر الرصيد في البنك",
      "cheques_zero": "لا شيكات",
      "cheques_one": "شيك واحد",
      "cheques_two": "شيكان",
      "cheques_few": "{{n}} شيكات",
      "cheques_many": "{{n}} شيكًا",
      "cheques_other": "{{n}} شيك",
      "plain": "شيكات تنتظر المتابعة"
    },
    "EMPLOYEE_DOCUMENTS_EXPIRING": {
      "summary": "{{documents}} بلغت موعد التذكير: {{expired}} منتهية، و{{within7}} تنتهي خلال 7 أيام، و{{within30}} خلال 30 يومًا",
      "documents_zero": "لا وثائق موظفين",
      "documents_one": "وثيقة موظف واحدة",
      "documents_two": "وثيقتا موظفين",
      "documents_few": "{{n}} وثائق موظفين",
      "documents_many": "{{n}} وثيقة موظفين",
      "documents_other": "{{n}} وثيقة موظفين",
      "plain": "وثائق موظفين قاربت على الانتهاء"
    }
  },
  "contractRecord": {
    "variation": "الأمر التغييري {{number}}",
    "variationTitled": "الأمر التغييري {{number}} «{{title}}»",
    "claim": "المستخلص {{number}}",
    "claimInterim": "المستخلص المرحلي حتى {{date}}",
    "claimFinal": "المستخلص الختامي",
    "claimDraft": "المستخلص"
  },
  "guaranteeName": {
    "numbered": "{{type}} رقم {{reference}}",
    "directed": "{{name}} ({{direction}})",
    "GIVEN": "مقدَّم",
    "RECEIVED": "مستلَم"
  },
  "contractName": "{{number}} ({{customer}})"
}
